
import React, { Fragment as F, useContext, useEffect, useState } from 'react'

import PeriodsCtx from './PeriodsCtx'
import PeriodsModal, { PeriodsC } from './PeriodsModal'

import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'
import { AppCtx } from "$src/App"



/**
 * PeriodsProvider
**/
const PeriodsProvider = ({ children, ...props }) => {
  const {
    periodsModalOpen: defaultPeriodsModalOpen = false,
  } = props
  // logg(props, 'PeriodsProvider')

  const apiRouter = useApiRouter()

  const {
    loading, setLoading,
    jwtToken,
  } = useContext(AppCtx)


  const [ periodsList, setPeriodsList ] = useState([])
  const [ relativeToAbsolute, setRelativeToAbsolute ] = useState({})
  const [ periodsModalOpen, setPeriodsModalOpen ] = useState(defaultPeriodsModalOpen)

  const defaultSelectedPeriods = JSON.parse(localStorage.getItem('selectedPeriods')) || { 'YTD 0': true }
  const [ selectedPeriods, _setSelectedPeriods ] = useState(defaultSelectedPeriods)
  const setSelectedPeriods = (ev) => {
    // logg(ev, 'settingSelectedPeriods')
    localStorage.setItem('selectedPeriods', JSON.stringify(ev))
    _setSelectedPeriods(ev)
  }

  const defaultSelectedPeriodsReverse = JSON.parse(localStorage.getItem('selectedPeriodsReverse')) || false
  const [ selectedPeriodsReverse, _setSelectedPeriodsReverse ] = useState(defaultSelectedPeriodsReverse)
  const setSelectedPeriodsReverse = (ev) => {
    localStorage.setItem('selectedPeriodsReverse', JSON.stringify(ev))
    _setSelectedPeriodsReverse(ev)
  }

  useEffect(() => {
    if (!jwtToken) { return; }
    setLoading(true)
    fetch(apiRouter.periodsPath()).then(r => r.json()).then(inns => {
      // logg(inns, 'got Periods List')
      setLoading(false)
      setPeriodsList(inns)

      const _relToAbs = {}
      inns.forEach((item, idx) => {
        _relToAbs[item.relative_s] = item.date
      })
      setRelativeToAbsolute(_relToAbs)
    })
  }, [ jwtToken ])

  return <PeriodsCtx.Provider value={{
    periodsList,
    periodsModalOpen,       setPeriodsModalOpen,
    relativeToAbsolute,     setRelativeToAbsolute,
    selectedPeriods,        setSelectedPeriods,
    selectedPeriodsReverse, setSelectedPeriodsReverse,
  }} >
    { children }
  </PeriodsCtx.Provider>
}

export {
  PeriodsC,
  PeriodsCtx,
  PeriodsModal,
  PeriodsProvider,


}
